"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../../../../scripts/helpers");
/** Реализует отрывающийся список. */
class Accordion extends HTMLElement {
    /** Создает открывающийся список. */
    constructor() {
        super();
        this.$button = this.querySelector('.accordion__header-button');
        this.$body = this.querySelector('.accordion__body');
        this.$bodyContainer = this.querySelector('.accordion__body-container');
        this.animationDuration = 0.3;
        this.focusableElementNodes = this.$body.querySelectorAll(helpers_1.focusElements);
        this.opened = this.hasAttribute('opened');
        this.contentVisible = this.hasAttribute('content-visible') || true;
        this.initialization();
    }
    /** Инициализирует элемент. */
    initialization() {
        this.$button.addEventListener('click', () => {
            if (this.opened) {
                this.close();
            }
            else {
                this.open();
            }
        });
        if (!this.opened) {
            this.$body.style.height = `0`;
        }
        window.addEventListener('resize', () => {
            this.resizeHandler();
        });
        this.setAttribute('inited', '');
    }
    /** Открывает список. */
    open() {
        this.opened = true;
        this.setAccessibilityLinks();
        this.setAttribute('opened', '');
        this.$body.addEventListener('transitionend', () => {
            this.$body.style.height = '';
        }, { once: true });
        requestAnimationFrame(() => {
            this.$body.style.height = `0`;
            requestAnimationFrame(() => {
                this.$body.style.height = `${this.$bodyContainer.scrollHeight}px`;
            });
        });
        // TODO: Продумать данную тему
        // this.$button.setAttribute('aria-label', this.$button.getAttribute('aria-label')?.replace('Открыть', 'Закрыть'));
    }
    /** Закрывает список. */
    close() {
        this.opened = false;
        this.unsetAccessibilityLinks();
        this.removeAttribute('opened');
        requestAnimationFrame(() => {
            this.$body.style.height = `${this.$bodyContainer.scrollHeight}px`;
            requestAnimationFrame(() => {
                this.$body.style.height = `0`;
            });
        });
        // TODO: Продумать данную тему
        // this.$button.setAttribute('aria-label', this.$button.getAttribute('aria-label')?.replace('Закрыть', 'Открыть'));
    }
    /** Обрабатывает изменение размера окна. */
    resizeHandler() {
        // TODO: Продумать данную тему
        // if (this.opened) {
        //   const $body = this.$el.querySelector('.accordion__body-container');
        //   this.$body.style.height = `${this.$body.scrollHeight}px`;
        // }
        // if (window.innerWidth > 991) {
        //   this.setAccessibilityLinks();
        // } else {
        //   if (this.opened) {
        //     this.setAccessibilityLinks();
        //   } else {
        //     this.unsetAccessibilityLinks();
        //   }
        // }
    }
    /** Устанавливает атрибуты доступности для интерактивных элементов. */
    setAccessibilityLinks() {
        this.focusableElementNodes.forEach($node => {
            $node.setAttribute('tabindex', '0');
        });
    }
    /** Убирает атрибуты доступности с интерактивных элементов. */
    unsetAccessibilityLinks() {
        this.focusableElementNodes = this.$body.querySelectorAll(helpers_1.focusElements);
        this.focusableElementNodes.forEach($node => {
            $node.setAttribute('tabindex', '-1');
        });
    }
}
exports.default = Accordion;
